import React, { useState } from 'react'
import { TextInputField } from 'evergreen-ui'
import BtnDefault from '../../Components/BtnDefault';
import * as yup from 'yup'; // for everything
import { toaster } from 'evergreen-ui/commonjs/toaster';
const InviteForm = ({
  close, save
}) => {
  const [user, setUser] = useState({
    email: '',
    name: ''
  })  
  const [errors, setErrors] = useState({})
  const schema = yup.object().shape({
    email: yup.string().email('Informe um e-mail válido').required(),
    name: yup.string().required()
  })

  async function validate(user) {
    setErrors({})
    toaster.closeAll()
    try {
      await schema.validate(user, {
        recursive: true,
        abortEarly: false
      })
      save(user)
    } catch (error) {
      toaster.danger(error.message)
      setErrors({
        email: error.message
      })
    }
  }

  const handleChange = ({ target }) => setUser({ ...user, [target.name]: target.value })

  const { email, name } = user
  return (
    <form onSubmit={(e) => {
      e.preventDefault()
      validate(user)
    }}>
      <TextInputField
        label='Nome'
        description=""
        name='name'
        placeholder='Nome'
        value={name} onChange={handleChange} />
      <TextInputField
        isInvalid={!!errors.email}
        label='E-mail'
        description=""
        name='email'
        placeholder='E-mail para envio do e-mail'
        value={email} onChange={handleChange} />
      <BtnDefault
        type='submit'
        disabled={!email.length || !name.length}
        appearance='primary' icon='envelope'> Enviar </BtnDefault>
    </form>
  )
}

export default InviteForm